import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_inventory_snapshot_rules_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { fullTextSearch?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, ownerId?: number, projectId?: number, warehouseId?: number, snapshotLevel?: string, ownerLookupcode?: string, projectLookupcode?: string, warehouseName?: string }[], totalCount?: number }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { fullTextSearch?: string, $keys: string[] }): Promise<{ result?: { id?: string, ownerId?: number, projectId?: number, warehouseId?: number, snapshotLevel?: string, ownerLookupcode?: string, projectLookupcode?: string, warehouseName?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      fullTextSearch?: string    }) {
      return false;
    }
}
